import { ChangeDetectorRef, Component, ElementRef, Injector } from '@angular/core';
import { UserDataService } from '../../../shared/sharedServices/user-data.service';
import { ToastData } from '../../models/interface/layout.interface';
import { environment } from '../../../../../environments/environment';
import { PermissionService } from '../../../shared/sharedModules/permission/permission.service';
import { UserDataShared } from '../../../shared/models/interface/userData.interface';
import { Router } from '@angular/router';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { MenuMode } from '../../models/interface/menuMode.enum';
import { PermissionMenuService } from 'src/app/components/shared/sharedModules/permission/permission-menu.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { ToastActions } from 'src/app/components/shared/sharedComponents/mu-toast/mu-toast-componet-enum';
import { LayoutMenuActions } from './layout.page.component.actions.enum';
import { MuLayoutService } from 'src/app/components/shared/sharedProtos/layout/mu-layout.service';
import { MuCookieService } from 'src/app/components/shared/sharedServices/mu-cookie.service';
import { accountTypeList } from 'src/environments/constants';

@Component({
  selector: 'app-layout.page',
  templateUrl: './layout.page.component.html',
  styleUrls: ['./layout.page.component.sass'],
})
export class LayoutPageComponent extends MuComponent {
  /**
   * Defined all variables
   */
  menu = MenuMode.overlay;

  layout = 'default';

  darkMenu = false;

  documentClickListener: () => void;

  staticMenuInactive: boolean;

  overlayMenuActive: boolean;

  mobileMenuActive: boolean;

  menuClick: boolean;

  menuButtonClick: boolean;

  topbarMenuButtonClick: boolean;

  topbarMenuActive: boolean;

  activeTopbarItem: Element;

  menuHoverActive: boolean;

  menuActivatedBySideArea: boolean;

  countrySel: string;

  toastData: ToastData;

  tokenLocal: string;

  userData: UserDataShared;

  offlineFlag: boolean;

  customLayoutContentClass: string;

  hideMenuValue = false;

  actionList: Actions<LayoutMenuActions, any> = new Actions<LayoutMenuActions, any>();
  toastActions: Actions<ToastActions, any> = new Actions<ToastActions, any>();
  helpLink: string;
  redirectLink: string;
  accountTypeIcon: string;

  private layoutServices: MuLayoutService;
  private userDataService: UserDataService;
  private permissionService: PermissionService;
  private elementRef: ElementRef;
  private permissionMenuService: PermissionMenuService;
  private router: Router;
  private changeDetectorRef: ChangeDetectorRef;
  private muCookieService: MuCookieService;

  constructor(private injector: Injector) {
    super();
    this.layoutServices = this.injector.get<MuLayoutService>(MuLayoutService);
    this.userDataService = this.injector.get<UserDataService>(UserDataService);
    this.permissionService = this.injector.get<PermissionService>(PermissionService);
    this.elementRef = this.injector.get<ElementRef>(ElementRef);
    this.permissionMenuService = this.injector.get<PermissionMenuService>(PermissionMenuService);
    this.router = this.injector.get<Router>(Router);
    this.changeDetectorRef = this.injector.get<ChangeDetectorRef>(ChangeDetectorRef);
    this.muCookieService = this.injector.get<MuCookieService>(MuCookieService);

    this.toastData = environment.toastData;
    this.watch(this.router.events).subscribe(_ => {
      this.layoutServices.setLayoutMain(this.elementRef);
    });
    this.watch(this.layoutServices.customLayoutContentClass$).subscribe((customLayoutContentClass: string) => {
      this.customLayoutContentClass = customLayoutContentClass;
      this.changeDetectorRef.detectChanges();
    });
    this.actionList.on(LayoutMenuActions.SIGN_OUT, () => {
      this.updateOnSignOut();
    });

    this.layoutServices.setToastAction(this.toastActions);
    this.getUserData();
  }

  muOnInit(): void {
    this.userDataService.setTokenLocalInStorage();
    this.userDataService.setUserDataInStorage();
    this.getTokenLocalService();
    this.getPermissionList();
    this.layoutServices.setLayoutMain(this.elementRef);
  }

  /**
   * inherit from parent MuComponent
   */
  muOnDestroy(): void {
    //empty
  }

  /**
   * method to get UserData
   */
  async getUserData(): Promise<void> {
    const data = localStorage.getItem('mu-data');
    if (!data) {
      this.hideMenuValue = true;
    }
    this.userData = await this.userDataService.getUserDataAsPromise();
    this.setDataForMenuAndTopBar();
  }

  /**
   * method to get token stored in cookie
   */
  getTokenLocalService(): void {
    this.tokenLocal = this.muCookieService.getCookie('token-mu');
  }

  /**
   * method to load permissions
   */
  async getPermissionList(): Promise<void> {
    await this.permissionService.getPermissionList();
    if (this.router.url !== '/dashboard') {
      return environment.guardClause;
    }
    const redirect = await this.permissionMenuService.getRedirectByPermission();
    if (redirect !== '/dashboard') {
      this.router.navigate([redirect]);
    }
  }

  /**
   * Event function to click in layout
   *
   * @return {boolean} menuClick
   * @return {boolean} menuButtonClic
   * @return {boolean} topbarMenuButtonClick
   */
  onLayoutClick() {
    if (!this.menuClick && !this.menuButtonClick) {
      if (this.slimMenu) {
        this.layoutServices.reset();
      }

      this.mobileMenuActive = false;
      this.overlayMenuActive = false;
      this.menuHoverActive = false;
    }

    if (!this.topbarMenuButtonClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    this.menuClick = false;
    this.menuButtonClick = false;
    this.topbarMenuButtonClick = false;
  }

  /**
   * Event function to click in layout
   *
   * @param {object} event An event which takes place in the DOM
   * @return {boolean} overlayMenuActive
   */

  updateMenuButtonClick(event: Event) {
    this.menuButtonClick = true;
    if (this.isMobile()) {
      this.mobileMenuActive = !this.mobileMenuActive;
    } else {
      if (this.staticMenu) {
        this.staticMenuInactive = !this.staticMenuInactive;
      } else if (this.overlayMenu) {
        this.overlayMenuActive = !this.overlayMenuActive;
      }
    }
  }

  /**
   * show Menu
   */
  showMenu($event: Event) {
    this.menuActivatedBySideArea = true;
    this.menuButtonClick = true;
    if (this.isMobile()) {
      this.mobileMenuActive = true;
    } else {
      if (this.staticMenu) {
        this.staticMenuInactive = true;
      } else if (this.overlayMenu) {
        this.overlayMenuActive = true;
      }
    }
    $event.preventDefault();
  }

  /**
   * show Menu
   */
  hideMenu($event: Event) {
    if (!this.menuActivatedBySideArea) {
      return environment.guardClause;
    }
    this.menuActivatedBySideArea = false;
    this.menuButtonClick = false;
    if (this.isMobile()) {
      this.mobileMenuActive = false;
    } else {
      if (this.staticMenu) {
        this.staticMenuInactive = false;
      } else if (this.overlayMenu) {
        this.overlayMenuActive = false;
      }
    }
    $event.preventDefault();
  }

  /**
   * Event function to click in layout
   *
   * @param {object} event An event which takes place in the DOM
   * @return {boolean} topbarMenuActive
   */

  updateTopbarMenuButtonClick(event: Event) {
    this.topbarMenuButtonClick = true;
    this.topbarMenuActive = !this.topbarMenuActive;
  }

  /**
   * update Function item click topbar
   *
   * @param {objects} item Element is the most general base class from which all objects in a Document inherit.
   * It only has methods and properties common to all kinds of elements.
   * More specific classes inherit from Element.
   * @return {boolean} activeTopbarItem
   */
  updateTopbarItemClick(item: Element) {
    this.topbarMenuButtonClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }
  }

  /**
   * Event function to click in layout
   *
   * @param {object} event An event which takes place in the DOM
   */

  onTopbarSubItemClick(event) {
    event.preventDefault();
  }

  /**
   * Event function to click in layout
   *
   * @param {object} event An event which takes place in the DOM
   */

  updateMenuClick(event: Event) {
    this.menuClick = true;
  }

  /**
   * function to validate type of menu
   *
   * @return {bolean} menu is SLIM mode
   */

  get slimMenu(): boolean {
    return this.menu === MenuMode.slim;
  }

  /**
   * function to validate type of menu
   *
   * @return {bolean} menu is OVERLAY mode
   */

  get overlayMenu(): boolean {
    return this.menu === MenuMode.overlay;
  }

  /**
   * function to validate type of menu
   *
   * @return {bolean} menu is STATIC mode
   */

  get staticMenu(): boolean {
    return this.menu === MenuMode.static;
  }

  /**
   * function to selected value
   *
   * @return {bolean} menu selected type SLIM
   */

  changeToSlimMenu() {
    this.menu = MenuMode.slim;
  }

  /**
   * function to selected value
   *
   * @return {bolean} menu selected type OVERLAY
   */

  changeToOverlayMenu() {
    this.menu = MenuMode.overlay;
  }

  /**
   * function to selected value
   *
   * @return {bolean} menu selected type STATIC
   */

  changeToStaticMenu() {
    this.menu = MenuMode.static;
  }

  /**
   * function to notificate event
   *
   * @return {bolean} validate is mobile resolution
   */

  isMobile() {
    return window.innerWidth <= 640;
  }

  /**
   * function to notificate event
   *
   * @param {boolean} value update value in variable layaout
   * @return {string} mobileMenuActive
   */

  isMobileMenuActive(value: boolean) {
    this.mobileMenuActive = value;
  }

  /**
   * method to close session
   */
  updateOnSignOut() {
    if (this.offlineFlag) {
      return this.router.navigate(['/page/login']);
    }
    this.userDataService.signOut();
  }

  /**
   * set data for menu and top bar
   */
  async setDataForMenuAndTopBar(): Promise<void> {
    this.helpLink = environment.helpLink;
    this.accountTypeIcon = accountTypeList.find(x => x.id === this.userData?.userType)?.icon?.toString();
    this.redirectLink = await this.permissionMenuService.getRedirectByPermission();
  }
}
